// Design tokens and domain helpers for the Station Calibration console.
// Single source for both the console and the sidebar tree — the product
// colours are a data scale, so the same hex must mean the same fuel in the
// rail dots, the silo fills and the station-card sparklines.

export const PRODUCTS = {
  PMS: { name: 'Petrol', color: '#0f9d63' },
  AGO: { name: 'Diesel', color: '#c97a1a' },
  DPK: { name: 'Kerosene', color: '#5c7f9c' },
  LPG: { name: 'Gas', color: '#8467c9' },
}

export const PRODUCT_ORDER = ['PMS', 'AGO', 'DPK', 'LPG']

export const RAIL = {
  bg: '#071620',
  raised: '#0e2530',
  text: '#8fa9b0',
  bright: '#eef6f4',
  dim: '#516a72',
}

export const ACCENT = { base: '#c97a1a', bright: '#e2932b', hover: '#b06914' }
export const GOOD = '#0f9d63'

export const CALIB_STEP = 0.05

/**
 * A product line = the tanks storing a product at a station + the pumps that
 * sell it. Pumps are not wired to a tank: they all draw from one shared
 * manifold, and the tank valves decide which tank is feeding it.
 */
export function productLines(station) {
  const products = new Set()
  ;(station?.tanks || []).forEach((t) => products.add(t.product))
  ;(station?.pumps || []).forEach((p) => products.add(p.product))
  return [...products]
    .sort((a, b) => PRODUCT_ORDER.indexOf(a) - PRODUCT_ORDER.indexOf(b))
    .map((product) => ({
      product,
      tanks: (station.tanks || []).filter((t) => t.product === product).sort((a, b) => a.tankNumber - b.tankNumber),
      pumps: (station.pumps || []).filter((p) => p.product === product).sort((a, b) => a.pumpNumber - b.pumpNumber),
    }))
}

export const sellingTanks = (tanks = []) => tanks.filter((t) => t.valveOpen)

export function sellingLabel(tanks = []) {
  const open = sellingTanks(tanks)
  if (open.length === 0) return null
  return open.map((t) => `Tank ${t.tankNumber}`).join(' & ')
}

/** Compact "T1+T2" form used in the rail. */
export function sellingMeta(tanks = []) {
  const open = sellingTanks(tanks)
  return open.length === 0 ? '—' : open.map((t) => `T${t.tankNumber}`).join('+')
}

export const remainingProducts = (station) => {
  const used = new Set(productLines(station).map((l) => l.product))
  return PRODUCT_ORDER.filter((p) => !used.has(p))
}

export const stationIsLive = (station) =>
  productLines(station).some((l) => l.tanks.length > 0 && l.pumps.length > 0)

export const fmtLitres = (n) => Number(n || 0).toLocaleString()
